<template>
  <div>
    <!--
    <b-card no-body >
      <b-card-body>
        <span>Programación de Fertilización</span>
      </b-card-body>
    </b-card>
    -->

    <b-card no-body v-if="estadoTablaAsistentes">
      <b-card-body>
        <b-row>
          <b-col lg="1">
            <b-form-group label-for="filterInput" class="mb-0">
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  @click="mostrarTemas"
                  id="btn_back"
                  v-b-tooltip.hover="'Regresar'"
              >
                <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
              </b-button>
            </b-form-group>
          </b-col>
          <b-col lg="11">
            <h4 class="text-bold font-weight-bold font-medium-1">
              Mostrando {{ items2.length }} asistentes para el tema: {{ tema }}
            </h4>
          </b-col>
        </b-row>
      </b-card-body>

      <b-table
          hover
          responsive
          small
          class="position-relative tablitaA"
          sticky-header="58vh"
          :items="items2"
          :fields="fields2"
          :filter="filter"
          :filter-included-fields="filterOn"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon
                v-if="
                data.item['nombres'] === '' ||
                data.item['nombres'] == null ||
                data.item['nombres'].length === 0
              "
                :id="`btn_${data.item.id}_editar`"
                icon="EditIcon"
                size="16"
                class="ml-1"
                @click="abrirModalEditar(data.item)"
            />
            <feather-icon
                :id="`btn_${data.item.id}_mostrarFotoFirma`"
                icon="ImageIcon"
                size="16"
                class="mx-1"
                @click="
                mostrarFoto(false, data.item.firma_foto, data.item.nombres)
              "
            />
          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>
        <template #cell(fecha)="data">
          <span
              class="text-nowrap"
              v-if="
              data.value === null || data.value === '' || data.value === ' '
            "
          ></span>
          <span class="text-nowrap" v-else>
            {{
              new Date(data.value.split('-')).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                timeZone: 'America/Lima',
              })
            }}
          </span>
        </template>
        <template #cell(asistente)="data">
          <span class="text-nowrap">
            <!-- {{ data.item.asistentes.length }} -->
          </span>
        </template>
      </b-table>
    </b-card>

    <b-card no-body v-else>
      <div class="m-1">
        <b-row>
          <b-col cols="12" lg="10" class="">
            <b-row>
              <b-col cols="12" lg="3">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="traerCapaAsis"
                      :disabled="!meses.length > 0 || loading"
                      v-b-tooltip.hover="'Recargar'"
                  >
                    <font-awesome-icon
                        icon="fa-solid fa-arrows-rotate"
                        :spin="loading"
                    />
                  </b-button>
                  <b-button
                      v-if="$can('create', 'Capacitaciones')"
                      variant="gradient-primary"
                      size="sm"
                      @click="exportarFile"
                      :disabled="loadingExcel"
                      v-b-tooltip.hover="'Exportar a Excel'"
                  >
                    <span v-if="loadingExcel">
                      <font-awesome-icon
                          icon="fa-solid fa-arrows-rotate"
                          spin
                      />
                    </span>
                    <span v-else>
                      <font-awesome-icon icon="fa-solid fa-file-excel"/>
                    </span>
                  </b-button>
                  <b-button
                      v-if="$can('create', 'Capacitaciones')"
                      variant="gradient-primary"
                      size="sm"
                      @click="exportarFilePDF(true, [])"
                      :disabled="loadingPDF"
                      v-b-tooltip.hover="'Exportar Documentos PDF'"
                  >
                    <span v-if="loadingPDF">
                      <font-awesome-icon
                          icon="fa-solid fa-arrows-rotate"
                          spin
                      />
                    </span>
                    <span v-else>
                      <font-awesome-icon icon="fa-solid fa-file-pdf"/>
                    </span>
                  </b-button>
                  <b-button
                      v-if="$can('create', 'Capacitaciones')"
                      title="Actualizar Registros"
                      variant="gradient-primary"
                      size="sm"
                      @click="rellenarVacios"
                      :disabled="loadingASI"
                      v-b-tooltip.hover="'Actualizar asistentes'"
                  >
                    <span v-if="loadingASI">
                      <font-awesome-icon
                          icon="fa-solid fa-arrows-rotate"
                          spin
                      />
                    </span>
                    <span v-else>
                      <font-awesome-icon icon="fa-solid fa-person"/>
                    </span>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      class="mr-1"
                      @click="borrarFiltro"
                      :disabled="loadingFiltro"
                      v-b-tooltip.hover="'Borrar todos los filtros'"
                  >
                    <font-awesome-icon icon="fa-solid fa-filter-circle-xmark"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group
                    label-for="filterInput"
                    class="m-lg-0 my-md-1 my-sm-1"
                >
                  <b-input-group size="sm">
                    <v-select
                        id="meses"
                        :options="mesesList"
                        v-model="meses"
                        multiple
                        :clearable="false"
                        class="select-size-sm"
                        placeholder="Seleccionar meses.."
                    />
                    <b-input-group-append>
                      <b-button
                          variant="gradient-primary"
                          :disabled="!meses.length > 0 || loading"
                          @click="traerCapaAsis"
                          v-b-tooltip.hover="'Buscar'"
                      >
                        <feather-icon icon="SearchIcon"/>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3">
                <b-form-group
                    label-for="filterInput"
                    class="m-lg-0 my-md-1 my-sm-1"
                >
                  <b-input-group size="sm">
                    <b-form-input
                        id="filterInput"
                        v-model="busqueda"
                        placeholder="Bsq Asistente"
                        class="form"
                    />
                    <b-input-group-append>
                      <b-button
                          variant="gradient-primary"
                          :disabled="!busqueda || loading"
                          @click="buscar"
                          v-b-tooltip.hover="'Buscar'"
                      >
                        <feather-icon icon="SearchIcon"/>
                      </b-button>
                      <b-button
                          variant="gradient-danger"
                          :disabled="!busqueda || loading"
                          @click="borrarBusqueda"
                          v-b-tooltip.hover="'Borrar Búsqueda'"
                      >
                        <feather-icon icon="XIcon"/>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <!--
            &emsp;&emsp;&emsp;
            <label>Filtro Fecha: </label>
            <b-input-group>
              <flat-pickr
                  v-model="fechaFiltro"
                  class="form-control"
                  :config="{wrap: true, mode: 'range', dateFormat: 'd/m/Y', locale: 'es'}"

                  @on-change="realizarFiltro('fecha', [fechaFiltro])"
              />
              <b-input-group-append>
                <b-button
                    variant="gradient-danger"
                    @click="realizarFiltro('fecha', [])"
                    v-b-tooltip.hover="'Borrar Filtro'"
                >
                  <feather-icon
                      icon="Trash2Icon"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            -->
          </b-col>
          <b-col
              cols="12"
              lg="2"
              class="d-flex align-items-center justify-content-end"
          >
            <label class="text-bold font-weight-bold font-small-4"
            >{{ totalRows }} registros</label
            >
          </b-col>
        </b-row>
      </div>

      <!--
      <b-table
          hover
          responsive
          small
          class="position-relative"
          sticky-header="58vh"
          :per-page="perPage"
          :current-page="currentPage"
          :items="itemsFiltro"
          :fields="fields"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(acciones)="data">
          <div class="text-nowrap">

            <feather-icon
                :id="`btn_${data.item.id}_mostrarFoto`"
                icon="ImageIcon"
                size="16"
                class="ml-1 text-dark"
                @click="mostrarFoto(true, data.item.foto_capacitacion, data.item.tema)"
            />

            <feather-icon
                :id="`btn_${data.item.id}_mostrarAsistentes`"
                icon="UsersIcon"
                size="16"
                class="ml-1 text-warning"
                @click="mostrarAsistente(data.item.id,data.item.tema)"
            />

&lt;!&ndash;

            <feather-icon
                v-if="data.item.tipo_capacitacion === 'VIRTUAL'"
                :id="`btn_${data.item.id}_mostrarLink`"
                icon="LinkIcon"
                size="16"
                class="mx-1 text-info"
                @click="verLinks(data.item.id, data.item.tema, data.item.created)"
            />
&ndash;&gt;

          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>
        <template #cell(fecha)="data">
          <span class="text-nowrap" v-if="data.value === null || data.value === '' || data.value === ' '"></span>
          <span class="text-nowrap" v-else>
            {{
              new Date(data.value.split('-')).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
        </template>
        <template #cell(n_asistentes)="data">
          <span class="text-nowrap">
            {{ data.value}}
          </span>
        </template>
        <template #cell(n_acta)="data">
          <span class="text-nowrap">
            {{ data.value.toString().padStart(6, '0') }}
          </span>
        </template>

        <template #head(empresa)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${empresa_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${empresa_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>EMPRESA</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Empresa" label-for="empresa_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="empresa_filtro"
                      v-model="empresa_filtro"
                      :options="empresaFiltro"
                      multiple
                      placeholder="Seleccionar empresa ..."
                      @input="realizarFiltro('empresa', empresa_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="empresa_filtro=[]; realizarFiltro('empresa', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(tema)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${tema_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${tema_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>TEMA</b>
              </template>
              <b-dropdown-form style="width: 350px!important;">
                <b-form-group label="Filtrar Tema" label-for="tema_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="tema_filtro"
                      v-model="tema_filtro"
                      :options="temaFiltro"
                      multiple
                      placeholder="Seleccionar tema ..."
                      @input="realizarFiltro('tema', tema_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="tema_filtro=[]; realizarFiltro('tema', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(area_responsable)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${area_responsable_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${area_responsable_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>ÁREA RESPONSABLE</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Área Responsbale" label-for="area_responsable_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="area_responsable_filtro"
                      v-model="area_responsable_filtro"
                      :options="area_responsableFiltro"
                      multiple
                      placeholder="Seleccionar area_responsable ..."
                      @input="realizarFiltro('area_responsable', area_responsable_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="area_responsable_filtro=[]; realizarFiltro('area_responsable', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

      </b-table>
      -->
      <hot-table
          ref="hotTableComponent"
          :data="items"
          licenseKey="non-commercial-and-evaluation"
      />
    </b-card>

    <b-modal
        id="modalVerFotos"
        v-model="verFoto"
        ok-title="Aceptar"
        ok-only
        :title="this.tema"
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <b-card
              :img-src="imagen"
              text-variant="white"
              img-alt="card img"
              body-class="bg-overlay"
          >
          </b-card>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
        id="modalVerLink"
        v-model="verLink"
        ok-title="Aceptar"
        ok-only
        title="Link"
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <a target="_blank" :href="link">{{ link }}</a>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
        id="modal-editar"
        ref="modal-editar"
        v-model="mostrarModalEditar"
        no-close-on-esc
        no-close-on-backdrop
        cancel-variant="secondary"
        ok-title="Editar"
        cancel-title="Cancelar"
        :cancel-disabled="loadingEditar"
        :ok-disabled="loadingEditar"
        size="md"
        centered
        title="Editar Asistente"
        @ok="okModalEditar"
    >
      <div v-if="loadingEditar" align="center">
        <p>Editando asistente ...</p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <div v-else>
        <validation-observer ref="editarAsistente">
          <b-form autocomplete="off" @submit.prevent="editarRegistro">
            <b-row>
              <b-col lg="12">
                <b-form-group label="DNI" label-for="DNI">
                  <validation-provider
                      #default="{ errors }"
                      name="dni"
                      vid="dni"
                      rules="required"
                  >
                    <b-form-input
                        id="dni"
                        name="dni"
                        v-model="dni"
                        :state="errors.length > 0 ? false : null"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <b-form-group label="Nombres" label-for="Nombres">
                  <validation-provider
                      #default="{ errors }"
                      name="nombres"
                      vid="nombres"
                      rules="required"
                  >
                    <b-form-input
                        id="nombres"
                        name="nombres"
                        v-model="nombres"
                        :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <b-form-group label="Genero" label-for="genero">
                  <validation-provider
                      #default="{ errors }"
                      name="Genero"
                      vid="genero"
                      rules="required"
                  >
                    <v-select
                        id="genero"
                        v-model="generoSelected"
                        :options="generos"
                        :reduce="(generos) => generos.value"
                        label="text"
                        key="value"
                        placeholder="Seleccionar genero..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <b-form-group label="Cargo" label-for="Cargo">
                  <validation-provider
                      #default="{ errors }"
                      name="cargo"
                      vid="cargo"
                  >
                    <b-form-input
                        id="cargo"
                        name="cargo"
                        v-model="cargo"
                        :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <b-form-group label="Área" label-for="Área">
                  <validation-provider
                      #default="{ errors }"
                      name="area"
                      vid="area"
                  >
                    <b-form-input
                        id="area"
                        name="area"
                        v-model="area"
                        :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <b-form-group label="Planilla" label-for="Planilla">
                  <validation-provider
                      #default="{ errors }"
                      name="planilla"
                      vid="planilla"
                  >
                    <b-form-input
                        id="planilla"
                        name="planilla"
                        v-model="planilla"
                        :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>

    <b-modal
        id="modalMaterial"
        v-model="verModalMaterial"
        ok-title="Aceptar"
        ok-only
        title="Registrar Material"
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <p><b>Tema: {{ temaMaterial }}</b></p>
          <a target="_blank" :href="link">{{ idMaterial }}</a>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCardBody,
  BCol,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownHeader,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  BPagination,
  BRow,
  BSpinner,
  BTable,
  BTooltip,
  VBTooltip,
} from 'bootstrap-vue'
import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import {HotTable} from '@handsontable/vue'
import {registerAllModules} from 'handsontable/registry'
import {esMX, registerLanguageDictionary} from 'handsontable/i18n'
import {ValidationProvider, ValidationObserver, localize} from 'vee-validate'
import {required} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import jsPDF from 'jspdf'

registerAllModules()
registerLanguageDictionary(esMX)

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BButtonGroup,
    BFormInput,
    BModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BTooltip,
    BInputGroupAppend,
    BInputGroup,
    BDropdown,
    BDropdownForm,
    BDropdownItem,
    BDropdownHeader,

    vSelect,
    VBTooltip,
    HotTable,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    loading: false,
    loadingExcel: false,
    loadingPDF: false,
    estadoTablaAsistentes: false,
    loadingASI: false,
    loadingFiltro: true,
    items: [],
    items2: [],
    perPage: 10,
    pageOptions: [10, 15, 20],
    totalRows: 0,
    currentPage: 1,
    filter: null,
    filterOn: [],
    fields: [
      {
        key: 'acciones',
        label: '#',
        thClass: 'text-center py-0 alinear-medioA',
        class: 'px-0 text-left',
        stickyColumn: true,
      },
      {
        key: 'estado',
        label: 'estado',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'codigo',
        label: 'Código',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'tipo_capacitacion',
        label: 'Tipo',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'modelo',
        label: 'Modelo',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'tema',
        label: 'tema',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'expositor',
        label: 'expositor',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'fecha',
        label: 'fecha',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'hora_inicio',
        label: 'hora inicio',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'hora_fin',
        label: 'hora fin',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'total_horas',
        label: 'Tiempo estimado',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'n_acta',
        label: 'N° Acta',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'participantes',
        label: 'participantes',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'n_asistentes',
        label: 'Asistentes',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'empresa',
        label: 'empresa',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'area_responsable',
        label: 'Área Responsable',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
    ],
    fields2: [
      {
        key: 'acciones',
        label: '#',
        thClass: 'text-center py-0 alinear-medioT',
        class: 'px-0 text-center',
        stickyColumn: true,
      },
      {
        key: 'dni',
        label: 'dni',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'nombres',
        label: 'nombres',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'genero',
        label: 'género',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'cargo',
        label: 'cargo',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'area',
        label: 'area',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'planilla',
        label: 'planilla',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
    ],
    status: [
      {
        0: 'Pendiente',
        1: 'En Proceso',
        3: 'Ejecutado',
      },
      {
        0: 'light-warning',
        1: 'light-info',
        3: 'light-success',
      },
    ],
    tema: null,
    imagen: null,
    verFoto: false,
    verLink: false,
    sideImg: require('@/assets/images/logo/agvLogo.png'),
    sideImg2: require('@/assets/images/logo/arvLogo.png'),
    selloAgv: require('@/assets/images/logo/sello_agv.png'),
    selloArv: require('@/assets/images/logo/sello_arv.png'),
    imgAsBase64: '',

    fechaFiltro: null,
    itemsFiltro: [],
    filtro: [
      {
        nombre: 'empresa',
        valor: []
      },
      {
        nombre: 'tema',
        valor: []
      },
      {
        nombre: 'area_responsable',
        valor: []
      },
      {
        nombre: 'fecha',
        valor: []
      },
    ],
    empresaFiltro: [],
    temaFiltro: [],
    area_responsableFiltro: [],

    empresa_filtro: [],
    tema_filtro: [],
    area_responsable_filtro: [],

    columnWidths: [
      null, // ID
      null, // ESTADO
      null, // CÓDIGO
      null, // TIPO
      null, // MODELO
      260, // TEMA
      null, // EXPOSITOR
      null, // FECHA
      null, // HORA INICIO
      null, // HORA FIN
      null, // TIEMPO ESTIMADO
      null, // N° ACTA
      null, // PARTICIPANTES
      null, // ASISTENTES
      null, // ÁREA RESPONSABLE
      null, // EMPRESA
      null, // unidad
      null, // sede
      null, // departamento
      null, // area
      null, // seccion
      null, // zona
      null, // MES
    ],

    busqueda: null,
    link: null,
    meses: [],
    mesesList: [],

    tabla: null,
    settings: null,

    estado: false, // Variable estado inicialmente en false
    swalInstance: null, // Instancia del swal
    mostrarModalEditar: false,
    loadingEditar: false,
    idEditarRegistro: null,
    dni: null,
    nombres: null,
    generos: [
      {
        value: 'M',
        text: 'MASCULINO'
      },
      {
        value: 'F',
        text: 'FEMENINO'
      },
    ],
    generoSelected: 'M',
    cargo: null,
    area: null,
    planilla: null,
    idCapacitacion: null,

    verModalMaterial: false,
    idMaterial: false,
    codMaterial: null,
    temaMaterial: null,
    material: null
  }),
  computed: {},
  mounted() {
    const yo = this
    yo.tabla = yo.$refs.hotTableComponent.hotInstance

    yo.settings = {
      width: '100%', //Ancho
      height: '55vh',
      rowHeaders: true, //Activar numeración de filas
      colHeaders: [
        'ID',
        'FOTO',
        'ESTADO',
        'CÓDIGO TEMA',
        'CÓDIGO MATERIAL',
        'TIPO',
        'MODELO',
        'TEMA',
        'EXPOSITOR',
        'FECHA',
        'HORA INICIO',
        'HORA FIN',
        'TIEMPO ESTIMADO',
        'N° ACTA',
        'PARTICIPANTES',
        'ASISTENTES',
        'ÁREA RESPONSABLE',
        'EMPRESA',
        'UNIDAD',
        'SEDE',
        'DEPARTAMENTO',
        'AREA',
        'SECCION',
        'ZONA',
        'MES',
        'CREATED',
        'MATERIAL',
      ],
      columns: [
        {
          data: 'id',
        },
        {
          data: 'foto_capacitacion',
        },
        {
          data: 'estado',
          filter: false,
          renderer(instance, td, row, col, prop, value, cellProperties) {
            let valor = ''

            valor = value === null ? '' : value

            const spd =
                valor === 'PENDIENTE'
                    ? 'light-warning'
                    : valor === 'REALIZADO'
                        ? 'light-success'
                        : valor === 'CANCELADO'
                            ? 'light-danger'
                            : valor === 'EN PROCESO'
                                ? 'light-info'
                                : 'light-dark'

            td.className = 'htCenter htMiddle'
            td.innerHTML =
                '<b-badge class="badge badge-' +
                spd +
                '">' +
                valor +
                '</b-badge>'

            return td
          },
        },
        {
          data: 'codigo',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'cod_material',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'tipo_capacitacion',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'modelo',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'tema',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'expositor',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'fecha',
          type: 'date',
          dateFormat: 'YYYY-MM-DD',
          className: 'htCenter htMiddle',
        },
        {
          data: 'hora_inicio',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'hora_fin',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'total_horas',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'n_acta',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'participantes',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'n_asistentes',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'area_responsable',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'empresa',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'unidad',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'sede',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'departamento',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'area',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'seccion',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'zona',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'mes_anio',
          className: 'htCenter htMiddle',
        },
        {
          data: 'created',
          className: 'htCenter htMiddle',
        },
        {
          data: 'material',
        },
      ],
      /*
      colWidths: [
        10, // ID
        88, // ESTADO
        88, // CÓDIGO
        92, // TIPO
        120, // MODELO
        260, // TEMA
        300, // EXPOSITOR
        93, // FECHA
        105, // HORA INICIO
        95, // HORA FIN
        140, // TIEMPO ESTIMADO
        90, // N° ACTA
        120, // PARTICIPANTES
        96, // ASISTENTES
        152, // ÁREA RESPONSABLE
        98, // EMPRESA
        90, // unidad
        135, // sede
        170, // departamento
        170, // area
        170, // seccion
        170, // zona
        90, // MES
      ],
      */
      language: esMX.languageCode, // Lenguaje español
      locale: 'es-MX',
      dropdownMenu: [
        'filter_by_condition',
        'filter_by_value',
        'filter_action_bar',
      ], // Activar menú
      filters: true,
      contextMenu: {
        items: {
          /*
          customAddRow: {
            name: 'Insertar fila',
            callback: function () {
              const selectedRow = this.getSelected()[0][0]; // Obtener la fila seleccionada
              const rowData = this.getDataAtRow(selectedRow); // Obtener los datos de la fila seleccionada
              // const newRowData = rowData.map((value) => value); // Crear una copia de los datos de la fila seleccionada
              console.log(rowData)

              this.alter('insert_row', selectedRow + 1, 1); // Agregar una fila nueva abajo de la fila seleccionada

              // const rowElement = this.getCell(selectedRow[0] + 1, 0).parentNode;
              // rowElement.classList.add("text-primary");

            },
          },

          "row_above": {
            name: "Insertar fila arriba",
            disabled: function () {
              return false;
            },
            callback: function () {
              this.alter("insert_row", this.getSelected()[0][0]);
            },
            icon: function () {
              var i = document.createElement("i");
              i.className = "fas fa-arrow-up";
              return i;
            }
          },
          "row_below": {
            name: "Insertar fila abajo",
            callback: function () {
              this.alter("insert_row", this.getSelected()[0][0] + 1);
            },
          },
          "remove_row": {
            name: "Eliminar fila",
            callback: function () {
              this.alter('remove_row', this.getSelected()[0][0]);
            }
          },


          row_below: {
            name: 'Agregar fila'
          },
          remove_row: {
            name: 'Eliminar fila'
          },
          */
          /*
          foto: {
            name: "Ver Foto",
            callback: function () {
              const rowData = this.getDataAtRow(this.getSelected()[0][0])
              if (rowData[0] != null && rowData[0]>0 && rowData[2]==='REALIZADO'){
                yo.mostrarFoto(true, rowData[1], rowData[6])
              }
            },
          },
          */
          asistentes: {
            name: 'Ver Asistentes',
            callback: function () {
              const rowData = this.getDataAtRow(this.getSelected()[0][0])
              if (rowData[0] != null && rowData[0] > 0) {
                yo.mostrarAsistente(rowData[0], rowData[7])
              }
            },
          },
          pdf: {
            name: 'Descargar PDF',
            callback: function () {
              if (yo.$can('create', 'Capacitaciones')) {
                const rowData = this.getDataAtRow(this.getSelected()[0][0])
                if (
                    rowData[0] != null &&
                    rowData[0] > 0 &&
                    rowData[2] === 'REALIZADO'
                ) {
                  yo.exportarFilePDF(false, [rowData[0]])
                }
              }

            },
          },
          link: {
            name: 'Ver Link',
            callback: function () {
              if (yo.$can('create', 'Capacitaciones')) {
                const rowData = this.getDataAtRow(this.getSelected()[0][0])

                if (
                    rowData[0] != null &&
                    rowData[0] > 0 &&
                    rowData[2] === 'EN PROCESO'
                ) {
                  yo.verLinks([rowData[0]], [rowData[6]], [rowData[25]])
                }
              }
            },
          },
          ver_material: {
            name: 'Descargar o Ver Material',
            callback: function () {
              if (yo.$can('create', 'Capacitaciones')) {
                const rowData = this.getDataAtRow(this.getSelected()[0][0])
                yo.descargarMaterial(rowData[26])
              }
            },
          },
        },
      },
      columnSorting: true,
      manualColumnResize: true,
      readOnly: true,
      afterFilter: yo.afterFilterFuncion,
    }

    this.generarListaMesesDesdeNoviembre2022()
    this.traerCapaAsis()
  },
  watch: {
    estado(newEstado) {
      if (newEstado) {
        this.mostrarSwal()
      } else {
        this.ocultarSwal()
      }
    },
  },
  methods: {
    traerCapaAsis() {
      const yo = this //Hago this de manera global
      yo.loading = true
      yo.tabla.updateData([])
      yo.totalRows = 0

      const hoy = new Date()
      const mes_actual =
          hoy.getFullYear() +
          '-' +
          (hoy.getMonth() + 1).toString()
              .padStart(2, '0')
      yo.meses = yo.meses.length > 0 ? yo.meses : [mes_actual]
      const data = JSON.stringify({
        meses: yo.meses,
      })

      const config = {
        method: 'post',
        url: '/capacitacion/capacitaciones_anidado/',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.items = response.data

              yo.tabla.updateData(response.data)
              yo.settings.hiddenColumns = {
                columns: [0, 1, 25, 26],
              }

              // yo.settings.colWidths = yo.columnWidths
              // yo.settings.autoColumnSize = true

              // yo.settings.colWidths[5] = 260

              yo.tabla.updateSettings(yo.settings)
              // yo.tabla.setColWidth(4, 150);

              // yo.tabla.getPlugin('filters').addCondition(16, 'by_value', [['2023-06']])
              // yo.tabla.getPlugin('filters').filter()

              yo.tabla.getPlugin('autoColumnSize')
                  .recalculateAllColumnsWidth()

              yo.totalRows = yo.items.length

              yo.loadingFiltro = true
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading = false
            // yo.realizarFiltro('', ['a'])
          })
    },

    handleSubmit() {
      this.$refs.formularioFertilizacion.validate()
          .then((success) => {
            if (success) {
              this.items.push({
                id: this.items.length + 1,
                semana: 23,
                cultivo: this.cultivo,
                etapa_fen: 'PRODUCTIVA',
                empresa: this.empresa,
                fundo: this.fundo,
                etapa: this.etapa,
                campo: this.campo,
                turno: this.turno,
                variedad: this.variedad,
                lote: this.lote,
                valvula: this.valvula,
                area: this.area,
                cod_producto: this.codigo,
                producto: this.producto,
                grupo_producto: this.grupo,
                subgrupo_producto: null,
                und_medida: this.uni_med,
                dias: this.dias,
                kg_ha_dia: this.kg_ha_dia,
                total_max_dia: this.total_max_dia,
                lun: this.lunes,
                mar: this.martes,
                mie: this.miercoles,
                jue: this.jueves,
                vie: this.viernes,
                sab: this.sabado,
                dom: this.domingo,
                estado: '0',
              })
              // Hide the modal manually
              this.$nextTick(() => {
                this.$refs['my-modal'].toggle('#toggle-btn')
              })
            }
          })
    },

    resetModal() {
      this.name = ''
      this.nameState = null

      this.cultivo = null
      this.empresa = null
      this.fundo = null
      this.etapa = null
      this.campo = null
      this.turno = null
      this.variedad = null
      this.lote = null
      this.valvula = null
      this.area = null
      this.codigo = null
      this.producto = null
      this.grupo = null
      this.uni_med = null
      this.dias = null
      this.kg_ha_dia = null
      this.total_max_dia = '0.0'
      this.lunes = '0.0'
      this.martes = '0.0'
      this.miercoles = '0.0'
      this.jueves = '0.0'
      this.viernes = '0.0'
      this.sabado = '0.0'
      this.domingo = '0.0'
      this.indicador = '0.0'
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    seleccionarTurno() {
      if (this.turno === 'TURNO 1-A') {
        this.lote = '3005-3006-3007-3008'
        this.valvula = '04-03-02-01'
        this.variedad = 'BILOXI'
        this.area = '11.09'
      } else {
        this.lote = '3001-3002-3003-3004'
        this.valvula = '08-07-06-05'
        this.variedad = 'BILOXI'
        this.area = '11.32'
      }
    },

    buscarProducto() {
      if (this.codigo === '2510041') {
        this.producto = '4CROPS MICROMIX (I.AHIERRO 20,ZINC 35GL)'
        this.grupo = 'FERT-BIOESTI-BIOREG'
        this.uni_med = 'L'
      } else if (this.codigo === '2510044') {
        this.producto = '4RESIST K (I.A FOSFITO POTASIO)'
        this.grupo = 'FERT-BIOESTI-BIOREG'
        this.uni_med = 'L'
      }
    },

    calcularMaxDia() {
      const kg = this.kg_ha_dia
      const are = this.area
      this.total_max_dia = (kg * are).toLocaleString('es-PE', {
        maximumFractionDigits: 2,
      })
    },

    mostrarAsistente(id, tema) {
      const yo = this
      yo.loading = true
      yo.idCapacitacion = id
      yo.tema = tema
      // yo.items2 = datos
      yo.estadoTablaAsistentes = true

      // ---------i
      const data = JSON.stringify({
        id: id,
      })

      const config = {
        method: 'post',
        url: '/capacitacion/asistentes/exportar/filter/',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.items2 = response.data
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading = false
          })

      // ----------------
    },

    async mostrarTemas() {
      const yo = this
      yo.estadoTablaAsistentes = false
      yo.loading = true
      yo.idCapacitacion = null

      setTimeout(function () {
        yo.tabla = yo.$refs.hotTableComponent.hotInstance
        yo.tabla.updateData(yo.items)
        yo.settings.hiddenColumns = {
          columns: [0, 1, 24],
        }
        yo.tabla.updateSettings(yo.settings)
        yo.totalRows = yo.items.length

        // Aquí puedes agregar cualquier otra lógica que necesites después de cambiar las variables
      }, 10)

      yo.loading = false
    },

    mostrarFoto(estado, foto, tema) {
      const yo = this
      yo.tema = estado
          ? 'Mostrando foto de la capacitación: ' + tema
          : 'Validación de asistencia de: ' + tema
      yo.verFoto = true
      yo.imagen = axiosIns.defaults.baseURL + foto
    },

    exportarFile() {
      const yo = this
      const spd = yo.tabla.getData()
          .map((subarray) => subarray[0])

      if (spd.length > 0) {
        yo.loadingExcel = true

        const data = JSON.stringify({
          datas: spd,
        })

        const config = {
          method: 'post',
          url: '/capacitacion/capacitaciones/exportar/filter/',
          headers: {
            'Content-Type': 'application/json',
          },
          responseType: 'arraybuffer',
          data: data,
        }

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                const fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                const fileLink = document.createElement('a')
                fileLink.href = fileURL

                const hoy = new Date()
                const fecha_hora =
                    hoy.getFullYear() +
                    '' +
                    (hoy.getMonth() + 1) +
                    '' +
                    hoy.getDate() +
                    '' +
                    hoy.getHours() +
                    '' +
                    hoy.getMinutes() +
                    '' +
                    hoy.getSeconds()

                fileLink.setAttribute(
                    'download',
                    'REPORTE DE CAPACITACIONES INTERNAS ' + fecha_hora + '.xlsx'
                )
                document.body.appendChild(fileLink)
                fileLink.click()

                yo.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    }
                )
              }
            })
            .catch(function (error) {
              console.log(error)
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loadingExcel = false
            })
      } else {
        yo.$toast(
            {
              component: ToastificationContent,
              props: {
                title: '¡Advertencia!',
                icon: 'AlertTriangleIcon',
                text: 'No se encuentran registros para exportar.',
                variant: 'warning',
              },
            },
            {
              position: 'top-center',
            }
        )
      }
    },

    async exportarFilePDF(estado, arrayS) {
      const yo = this

      yo.loadingPDF = true
      yo.estado = true
      let ids = []
      ids = estado ? yo.tabla.getData()
          .map((subarray) => subarray[0]) : arrayS

      var spd = yo.items.filter((registro) => ids.includes(registro.id))
      if (spd.length === 0) {
        spd = yo.itemsFiltro.filter((registro) => ids.includes(registro.id))
      }

      let pdfCounter = 0

      for (const value of spd) {
        const data = JSON.stringify({
          id: value.id,
        })

        const config = {
          method: 'post',
          url: '/capacitacion/asistentes/exportar/filter/',
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        }

        axiosIns(config)
            .then(async function (response) {
              if (response.status === 200) {
                const asistentes = response.data
                /*
                const imageUrls = asistentes.map((imagen) => axiosIns.defaults.baseURL + imagen.firma_foto)
                const promises = imageUrls.map((url) => {
                  return new Promise((resolve) => {
                    const img = new Image();
                    img.onload = () => resolve()
                    img.src = url
                  });
                })

                await Promise.all(promises)
                */

                let ini = -7
                let fin = 12

                const imgLogo =
                    value.empresa === 'AGROVISION' ? yo.sideImg : yo.sideImg2
                const imgSello =
                    value.empresa === 'AGROVISION' ? yo.selloAgv : yo.selloArv

                const fecha1 = new Date(value.fecha.split('-')).toLocaleString(
                    'pe-PE',
                    {
                      year: 'numeric',
                      month: 'long',
                      day: '2-digit',
                      localeMatcher: 'best fit',
                      timeZone: 'America/Lima',
                    }
                )

                const fecha2 = new Date(value.fecha.split('-')).toLocaleString(
                    'pe-PE',
                    {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      localeMatcher: 'best fit',
                      timeZone: 'America/Lima',
                    }
                )
                var totalHojas =
                    value.n_asistentes > 12
                        ? Math.ceil((value.n_asistentes - 12) / 20) + 1
                        : 1
                if (value?.n_asistentes === undefined) {
                  totalHojas =
                      value.nasistentes > 12
                          ? Math.ceil((value.nasistentes - 12) / 20) + 1
                          : 1
                }

                const doc = new jsPDF({
                  orientation: 'p',
                  unit: 'mm', // Dimensiones A4: 210 x 297 mm
                  format: 'a4',
                })

                const ancho_t =
                    value.tema.length > 180
                        ? 13.5
                        : value.tema.length > 120
                            ? 9
                            : value.tema.length > 60
                                ? 4.5
                                : 0
                const ancho_temario =
                    value.temario.length > 605
                        ? 49.5
                        : value.temario.length > 550
                            ? 45
                            : value.temario.length > 495
                                ? 40.5
                                : value.temario.length > 440
                                    ? 36
                                    : value.temario.length > 385
                                        ? 31.5
                                        : value.temario.length > 330
                                            ? 27
                                            : value.temario.length > 275
                                                ? 22.5
                                                : value.temario.length > 220
                                                    ? 18
                                                    : value.temario.length > 165
                                                        ? 13.5
                                                        : value.temario.length > 110
                                                            ? 9
                                                            : value.temario.length > 55
                                                                ? 4.5
                                                                : 0

                doc.addImage(
                    imgLogo,
                    'PNG',
                    172.75,
                    8.5,
                    17,
                    15,
                    'agv',
                    'NONE',
                    0
                )
                doc.setFont(undefined, 'bold')
                doc.setFontSize(11)
                doc.text('INFORME DE ' + value.area_responsable, 105, 39, {
                  align: 'center',
                  baseline: 'middle',
                  maxWidth: 195,
                })
                doc.text('Para', 32, 55.75)
                doc.text('De', 32, 63.25)
                doc.text('Tema', 32, 70.75)
                doc.text('Fecha', 32, 78.25 + ancho_t)
                doc.text(':', 43, 55.75)
                doc.text(':', 43, 63.25)
                doc.text(':', 43, 70.75)
                doc.text(':', 43, 78.25 + ancho_t)

                doc.setFont(undefined, 'normal')
                doc.setFontSize(10)

                doc.text(
                    value.empresa === 'AGROVISION'
                        ? 'AGROVISION PERÚ S.A.C'
                        : 'ARENA VERDE S.A.C',
                    46,
                    54.5,
                    {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 136
                    }
                )
                doc.text(
                    value.expositor != null ? value.expositor : '--',
                    46,
                    62,
                    {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 136
                    }
                )
                doc.text(value.tema, 46, 69.5, {
                  align: 'justify',
                  baseline: 'middle',
                  maxWidth: 136,
                })
                doc.text(fecha1.toString(), 46, 77 + ancho_t, {
                  align: 'justify',
                  baseline: 'middle',
                  maxWidth: 136,
                })

                doc.setLineWidth(0.6)
                doc.line(28, 90 + ancho_t, 182, 90 + ancho_t)
                // doc.setFontSize(11)
                doc.text(
                    'Por el presente adjunto evidencia de capacitación que se realizó el día ' +
                    fecha2.toString(),
                    29,
                    102.75 + ancho_t
                )
                doc.text(
                    'Hora: ' + value.hora_inicio + ' - ' + value.hora_fin,
                    29,
                    110.25 + ancho_t
                )
                doc.text('Zona: ' + value.zona, 29, 117.75 + ancho_t)
                doc.text('Cultivo: ' + value.cultivo, 29, 125.25 + ancho_t)
                doc.text('Tema: ', 29, 132.75 + ancho_t)
                doc.text(value.tema, 42, 131.5 + ancho_t, {
                  align: 'justify',
                  baseline: 'middle',
                  maxWidth: 141,
                })
                doc.text('Temario: ', 29, 140.25 + ancho_t + ancho_t)
                doc.text(value.temario, 45, 139 + ancho_t + ancho_t, {
                  align: 'justify',
                  baseline: 'middle',
                  maxWidth: 137,
                })
                doc.text(
                    'Grupo Objetivo: ' + value.planilla,
                    29,
                    147.75 + ancho_t + ancho_t + ancho_temario
                )
                doc.text(
                    value.expositor != null
                        ? 'Expositor: ' + value.expositor
                        : '--',
                    29,
                    155.25 + ancho_t + ancho_t + ancho_temario
                )
                doc.text(
                    'Sede: ' + value.sede,
                    29,
                    162.75 + ancho_t + ancho_t + ancho_temario
                )
                doc.text(
                    'Departamento: ' + value.departamento,
                    29,
                    170.25 + ancho_t + ancho_t + ancho_temario
                )
                doc.text(
                    'Área: ' + value.area,
                    29,
                    177.75 + ancho_t + ancho_t + ancho_temario
                )
                doc.text(
                    'Sección: ' + value.seccion,
                    29,
                    185.25 + ancho_t + ancho_t + ancho_temario
                )
                doc.text(
                    'N° de participantes: ' +
                    (value?.n_asistentes === undefined
                        ? value.nasistentes
                        : value.n_asistentes),
                    29,
                    192.75 + ancho_t + ancho_t + ancho_temario
                )
                doc.text(
                    'Código del material del tema: ' +
                    (value?.cod_material === undefined
                        ? '---'
                        : value.cod_material),
                    29,
                    200.25 + ancho_t + ancho_t + ancho_temario
                )
                doc.setFillColor('#00b050') // Color verde en formato hexadecimal
                doc.rect(176, 270, 7.5, 7.5, 'F')

                doc.setTextColor('#FFFFFF') // Color blanco para el número
                doc.text('1', 179.5, 274.7, {align: 'center'})
                doc.setTextColor('#000000')
                doc.text(
                    value.empresa === 'AGROVISION'
                        ? 'AGROVISION PERÚ S.A.C'
                        : 'ARENA VERDE S.A.C',
                    172,
                    273.8,
                    {
                      align: 'right',
                      baseline: 'middle'
                    }
                )

                doc.addPage()

                doc.addImage(
                    yo.sideImg,
                    'PNG',
                    172.75,
                    8.5,
                    17,
                    15,
                    'agv',
                    'NONE',
                    0
                )

                doc.text('Atentamente,', 29, 28)

                // await yo.addImageAsync2(doc, axiosIns.defaults.baseURL + value.foto_capacitacion, "PNG")


                console.log("in", value.foto_capacitacion)

                value.foto_capacitacion !== null && value.foto_capacitacion !== ''
                    ? await yo.addImageAsync2(
                        doc,
                        axiosIns.defaults.baseURL + value.foto_capacitacion,
                        'PNG'
                    )
                    : ''

                doc.setFillColor('#00b050') // Color verde en formato hexadecimal
                doc.rect(176, 270, 7.5, 7.5, 'F')

                doc.setTextColor('#FFFFFF') // Color blanco para el número
                doc.text('2', 179.5, 274.7, {align: 'center'})
                doc.setTextColor('#000000')
                doc.text(
                    value.empresa === 'AGROVISION'
                        ? 'AGROVISION PERÚ S.A.C'
                        : 'ARENA VERDE S.A.C',
                    172,
                    273.8,
                    {
                      align: 'right',
                      baseline: 'middle'
                    }
                )

                if (value.foto_capacitacion2 !== null && value.foto_capacitacion2 !== '') {
                  doc.addPage()

                  doc.addImage(
                      yo.sideImg,
                      'PNG',
                      172.75,
                      8.5,
                      17,
                      15,
                      'agv',
                      'NONE',
                      0
                  )

                  console.log("in2", value.foto_capacitacion2)


                  await yo.addImageAsync2(
                      doc,
                      axiosIns.defaults.baseURL + value.foto_capacitacion2 + "?nocache=" + new Date().getTime(),
                      'PNG'
                  )

                  doc.setFillColor('#00b050') // Color verde en formato hexadecimal
                  doc.rect(176, 270, 7.5, 7.5, 'F')

                  doc.setTextColor('#FFFFFF') // Color blanco para el número
                  doc.text('3', 179.5, 274.7, {align: 'center'})
                  doc.setTextColor('#000000')
                  doc.text(
                      value.empresa === 'AGROVISION'
                          ? 'AGROVISION PERÚ S.A.C'
                          : 'ARENA VERDE S.A.C',
                      172,
                      273.8,
                      {
                        align: 'right',
                        baseline: 'middle'
                      }
                  )
                }

                if (value.foto_capacitacion3 !== null && value.foto_capacitacion3 !== '') {
                  doc.addPage()

                  doc.addImage(
                      yo.sideImg,
                      'PNG',
                      172.75,
                      8.5,
                      17,
                      15,
                      'agv',
                      'NONE',
                      0
                  )


                  console.log("in3", value.foto_capacitacion3)

                  await yo.addImageAsync2(
                      doc,
                      axiosIns.defaults.baseURL + value.foto_capacitacion3 + "?nocache=" + new Date().getTime(),
                      'PNG'
                  )


                  doc.setFillColor('#00b050') // Color verde en formato hexadecimal
                  doc.rect(176, 270, 7.5, 7.5, 'F')

                  doc.setTextColor('#FFFFFF') // Color blanco para el número
                  doc.text('4', 179.5, 274.7, {align: 'center'})
                  doc.setTextColor('#000000')
                  doc.text(
                      value.empresa === 'AGROVISION'
                          ? 'AGROVISION PERÚ S.A.C'
                          : 'ARENA VERDE S.A.C',
                      172,
                      273.8,
                      {
                        align: 'right',
                        baseline: 'middle'
                      }
                  )
                }

                doc.addPage()

                for (let j = 1; j <= totalHojas; j++) {
                  if (j === 1) {
                    doc.setLineWidth(0.4)
                    doc.rect(7.5, 7.5, 195, 15)
                    doc.setLineWidth(0.225)
                    doc.line(46.5, 7.5, 46.5, 22.5)
                    doc.line(163.5, 7.5, 163.5, 22.5)
                    doc.line(46.5, 15, 163.5, 15)

                    doc.addImage(
                        imgLogo,
                        'PNG',
                        20.5,
                        8.5,
                        13,
                        13,
                        'agv',
                        'NONE',
                        0
                    )
                    doc.addImage(
                        imgSello,
                        'PNG',
                        176,
                        268.5,
                        13,
                        13,
                        'selloagv',
                        'NONE',
                        0
                    ) // await addImageAsync(doc, imageUrl, "PNG", 113, 268.5, 20, 13, "firmaexp", "NONE", 0)

                    doc.setFont('courier', 'italic', 'bold')
                    doc.setFontSize(6.8)
                    value.firma_expositor !== null && value.firma_expositor !== ''
                        ? await yo.addImageAsync(
                            doc,
                            axiosIns.defaults.baseURL + value.firma_expositor,
                            'PNG',
                            113,
                            268.5,
                            20,
                            13,
                            'firmaexp',
                            'NONE',
                            0
                        )
                        : value.expositor != null
                            ? doc.text(value.expositor, 122.5, 277.5, {
                              align: 'center',
                              baseline: 'middle',
                              maxWidth: 50,
                            })
                            : ''
                    doc.setFont('helvetica', 'normal', 'normal')
                    doc.setFontSize(8)
                    doc.text('FORMATO', 105, 11.25, {
                      align: 'center',
                      baseline: 'middle',
                    })
                    doc.text(
                        'REGISTRO DE INDUCCIÓN, CAPACITACIÓN, ENTRENAMIENTO Y SIMULACRO',
                        105,
                        18.75,
                        {
                          align: 'center',
                          baseline: 'middle',
                        }
                    )
                    doc.setFontSize(6)
                    doc.text(
                        `Código: GH-GD-FO-0609\nRevisión: 006\nFecha: 03/12/2021\nPágina: 1 de ${totalHojas}`,
                        165,
                        12.125,
                        {align: 'left'}
                    )

                    doc.line(162.5, 282.5, 202.5, 282.5)
                    doc.line(102.5, 282.5, 142.5, 282.5)

                    doc.line(182.5, 28.5, 202.5, 28.5)
                    doc.text(
                        value.n_acta != null
                            ? `${value.n_acta.toString()
                                .padStart(6, '0')}`
                            : '0'.padStart(6, '0'),
                        192.5,
                        27.75,
                        {align: 'center'}
                    )
                    doc.setFont(undefined, 'bold')
                    doc.text('CÓDIGO DE ACTA: ', 181.5, 27.75, {
                      align: 'right',
                    })
                    doc.setFontSize(8)
                    doc.text('TEMA:', 7.5, 33)
                    doc.text('TEMARIO:', 7.5, 39)
                    doc.text('V°B° C&D', 182.5, 287, {
                      align: 'center',
                      baseline: 'bottom',
                    })
                    doc.text('FIRMA DEL EXPOSITOR', 122.5, 285.75, {
                      align: 'center',
                      baseline: 'bottom',
                    })
                    doc.text(
                        value.dni_expositor != null
                            ? `DNI: ${value.dni_expositor}`
                            : 'DNI: --',
                        122.5,
                        289.5,
                        {
                          align: 'center',
                          baseline: 'bottom',
                        }
                    )
                    doc.setFontSize(6.75)
                    doc.setFont(undefined, 'normal')
                    doc.text(value.tema != null ? value.tema : '--', 23.5, 33)
                    doc.line(23, 33.75, 202.5, 33.75)
                    doc.line(23, 39.75, 202.5, 39.75)
                    doc.line(23, 43.75, 202.5, 43.75)
                    doc.text(
                        value.temario != null ? value.temario : '--',
                        23.5,
                        39,
                        {
                          align: 'justify',
                          lineHeightFactor: 1.75,
                          maxWidth: 177.5,
                        }
                    )

                    doc.setLineWidth(0.4)
                    doc.rect(7.5, 47.75, 195, 60)
                    doc.setLineWidth(0.225)
                    doc.line(7.5, 55.75, 202.5, 55.75)
                    doc.line(7.5, 63.75, 202.5, 63.75)
                    doc.line(151, 73, 195, 73)
                    doc.line(7.5, 75.75, 202.5, 75.75)
                    doc.line(7.5, 83.75, 202.5, 83.75)
                    doc.line(7.5, 91.75, 202.5, 91.75)
                    doc.line(7.5, 99.75, 202.5, 99.75)

                    doc.line(144, 47.75, 144, 55.75)
                    doc.line(105, 55.75, 105, 63.75)

                    doc.line(42.5, 75.75, 42.5, 83.75)

                    doc.line(56.25, 83.75, 56.25, 91.75)
                    doc.line(153.75, 83.75, 153.75, 91.75)

                    doc.line(97.5, 91.75, 97.5, 99.75)
                    doc.line(137.5, 91.75, 137.5, 99.75)

                    doc.line(105, 99.75, 105, 107.75)

                    doc.line(31.875, 115.75, 80.625, 115.75)
                    doc.line(129.375, 115.75, 178.125, 115.75)

                    let pp = 139.5
                    let ww = 139
                    let co = 0
                    var tot = value.n_asistentes > 12 ? 12 : value.n_asistentes
                    if (value?.n_asistentes === undefined) {
                      tot = value.nasistentes > 12 ? 12 : value.nasistentes
                    }

                    for (let i = 0; i < 12; i++) {
                      doc.line(14, pp, 30.5, pp)
                      doc.line(33.5, pp, 63.25, pp)
                      doc.line(64.75, pp, 103.5, pp)
                      doc.line(106.5, pp, 180, pp)
                      doc.line(183, pp, 201, pp)

                      doc.text('/', 64, pp, {
                        align: 'center',
                        baseline: 'bottom',
                      })
                      doc.text(`${i + 1}`, 10, pp, {
                        align: 'center',
                        baseline: 'bottom',
                      })

                      if (i < tot) {
                        doc.text(asistentes[i].dni, 22.25, ww, {
                          align: 'center',
                          baseline: 'bottom',
                        })
                        doc.text(asistentes[i].nombres, 143.25, ww, {
                          align: 'center',
                          baseline: 'bottom',
                        })
                        doc.setFontSize(6)
                        doc.text(asistentes[i].area, 48.375, ww - 3, {
                          align: 'center',
                          baseline: 'ideographic',
                          maxWidth: 28,
                        })
                        doc.setFontSize(6.75)
                        doc.text(asistentes[i].cargo, 84.125, ww - 3, {
                          align: 'center',
                          baseline: 'ideographic',
                          maxWidth: 36,
                        })
                        doc.setFont('courier', 'italic', 'bold')
                        doc.setFontSize(4.25)
                        // asistentes[i].firma_foto !== null && asistentes[i].firma_foto !== '' ? await yo.addImageAsync(doc, axiosIns.defaults.baseURL + asistentes[i].firma_foto, "PNG", 186, ww - 8, 12, 8) : ""
                        asistentes[i].firma_foto !== null &&
                        asistentes[i].firma_foto !== ''
                            ? await yo.addImageAsync(
                                doc,
                                axiosIns.defaults.baseURL +
                                asistentes[i].firma_foto,
                                'PNG',
                                186,
                                ww - 8,
                                12,
                                8
                            )
                            : doc.text(asistentes[i].nombres, 192, ww - 8 + 5, {
                              align: 'center',
                              baseline: 'middle',
                              maxWidth: 20,
                            })
                      }

                      doc.setFontSize(6.75)
                      doc.setFont('helvetica', 'normal', 'normal')

                      pp = pp + 11
                      ww = ww + 11
                      co++
                    }
                    doc.setFontSize(6.75)
                    doc.setFont('helvetica', 'normal', 'bold')
                    doc.text('ACTIVIDAD:', 9, 51.75, {baseline: 'middle'})
                    doc.text('ACCIÓN CORRECTIVA:', 145.5, 51.75, {
                      baseline: 'middle',
                    })
                    doc.text('MODALIDAD DE LA CAPACITACIÓN:', 9, 59.75, {
                      baseline: 'middle',
                    })
                    doc.text('ESCUELA:', 106.5, 59.75, {baseline: 'middle'})
                    doc.text('CATEGORÍAS:', 9, 67.75, {baseline: 'middle'})
                    doc.text('FECHA:', 9, 79.75, {baseline: 'middle'})
                    doc.text('HORA INICIO:', 44, 79.75, {baseline: 'middle'})
                    doc.text('HORA TÉRMINO:', 97, 79.75, {baseline: 'middle'})
                    doc.text('TIEMPO ESTIMADO:', 151, 79.75, {
                      baseline: 'middle',
                    })
                    doc.text('SEDE:', 9, 87.75, {baseline: 'middle'})
                    doc.text('DEPARTAMENTO:', 57.75, 87.75, {
                      baseline: 'middle',
                    })
                    doc.text('ÁREA:', 155.25, 87.75, {baseline: 'middle'})
                    doc.text('SECCIÓN:', 9, 95.75, {baseline: 'middle'})
                    doc.text('ZONA:', 99, 95.75, {baseline: 'middle'})
                    doc.text('GRUPO OBJETIVO:', 139, 95.75, {
                      baseline: 'middle',
                    })
                    doc.text('CULTIVO:', 9, 103.75, {baseline: 'middle'})
                    doc.text('UNIDAD:', 106.5, 103.75, {baseline: 'middle'})

                    doc.text('N°', 9, 126.75, {baseline: 'middle'})
                    doc.text('DNI', 22.25, 126.75, {
                      align: 'center',
                      baseline: 'middle',
                    })
                    doc.text('FIRMA', 191.25, 126.75, {
                      align: 'center',
                      baseline: 'middle',
                    })
                    doc.text('ÁREA / CARGO', 68.5, 126.75, {
                      align: 'center',
                      baseline: 'middle',
                    })
                    doc.text('APELLIDOS Y NOMBRES', 138, 126.75, {
                      align: 'center',
                      baseline: 'middle',
                    })

                    doc.text('NOMBRE DEL EXPOSITOR', 56.25, 117.25, {
                      align: 'center',
                      baseline: 'middle',
                    })
                    doc.text('INSTITUCIÓN DE PROCEDENCIA', 153.75, 117.25, {
                      align: 'center',
                      baseline: 'middle',
                    })

                    doc.setFont(undefined, 'normal')
                    doc.text('Inducción', 30, 51.75, {baseline: 'middle'})
                    doc.rect(41, 50.5, 2.5, 2.5)
                    value.actividad === 'INDUCCIÓN'
                        ? doc.text('X', 42.25, 51.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('Capacitación', 47.25, 51.75, {
                      baseline: 'middle',
                    })
                    doc.rect(62, 50.5, 2.5, 2.5)
                    value.actividad === 'CAPACITACIÓN'
                        ? doc.text('X', 63.25, 51.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('Entrenamiento', 68.25, 51.75, {
                      baseline: 'middle',
                    })
                    doc.rect(84.75, 50.5, 2.5, 2.5)
                    value.actividad === 'ENTRENAMIENTO'
                        ? doc.text('X', 86, 51.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('Simulacro', 91, 51.75, {baseline: 'middle'})
                    doc.rect(102.75, 50.5, 2.5, 2.5)
                    value.actividad === 'SIMULACRO'
                        ? doc.text('X', 104, 51.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('Charla', 109, 51.75, {baseline: 'middle'})
                    doc.rect(117.25, 50.5, 2.5, 2.5)
                    value.actividad === 'CHARLA'
                        ? doc.text('X', 118.5, 51.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('SI', 178, 51.75, {baseline: 'middle'})
                    doc.rect(181.25, 50.5, 2.5, 2.5)
                    value.fecha_ejecucion === 'SI'
                        ? doc.text('X', 182.5, 51.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('NO', 187.75, 51.75, {baseline: 'middle'})
                    doc.rect(192.5, 50.5, 2.5, 2.5)
                    value.fecha_ejecucion === 'NO'
                        ? doc.text('X', 193.75, 51.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('Interna', 58.5, 59.75, {baseline: 'middle'})
                    doc.rect(67.25, 58.5, 2.5, 2.5)
                    value.modalidad === 'INTERNA'
                        ? doc.text('X', 68.5, 59.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('Inhouse', 73.5, 59.75, {baseline: 'middle'})
                    doc.rect(83.5, 58.5, 2.5, 2.5)
                    value.modalidad === 'INHOUSE'
                        ? doc.text('X', 84.75, 59.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('SIG', 124, 59.75, {baseline: 'middle'})
                    doc.rect(129.25, 58.5, 2.5, 2.5)
                    value.escuela === 'SISTEMA INTEGRADO DE GESTIÓN'
                        ? doc.text('X', 130.5, 59.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('Técnica', 135.5, 59.75, {baseline: 'middle'})
                    doc.rect(144.75, 58.5, 2.5, 2.5)
                    value.escuela === 'TÉCNICA'
                        ? doc.text('X', 146, 59.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('Gestión y Liderazgo', 151, 59.75, {
                      baseline: 'middle',
                    })
                    doc.rect(173.25, 58.5, 2.5, 2.5)
                    value.escuela === 'GESTIÓN Y LIDERAZGO'
                        ? doc.text('X', 174.5, 59.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('Otros', 179.5, 59.75, {baseline: 'middle'})
                    doc.rect(186.25, 58.5, 2.5, 2.5)
                    value.escuela === 'OTROS'
                        ? doc.text('X', 187.5, 59.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('SEGURIDAD Y SALUD EN EL TRABAJO', 32.5, 67.75, {
                      baseline: 'middle',
                    })
                    doc.rect(78.25, 66.5, 2.5, 2.5)
                    value.categoria === 'SEGURIDAD Y SALUD EN EL TRABAJO'
                        ? doc.text('X', 79.5, 67.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('BRCGS/IFS', 82.00, 67.75, {baseline: 'middle'})
                    doc.rect(95.5, 66.5, 2.5, 2.5)
                    value.categoria === 'BRCGS/IFS'
                        ? doc.text('X', 96.75, 67.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('GLOBAL GAP', 102, 67.75, {baseline: 'middle'})
                    doc.rect(118.5, 66.5, 2.5, 2.5)
                    value.categoria === 'GLOBAL GAP'
                        ? doc.text('X', 119.75, 67.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('BASC', 125, 67.75, {baseline: 'middle'})
                    doc.rect(132.5, 66.5, 2.5, 2.5)
                    value.categoria === 'BASC'
                        ? doc.text('X', 133.75, 67.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('FSMA', 139, 67.75, {baseline: 'middle'})
                    doc.rect(147, 66.5, 2.5, 2.5)
                    value.categoria === 'FSMA'
                        ? doc.text('X', 148.25, 67.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('BPM', 153.5, 67.75, {baseline: 'middle'})
                    doc.rect(160, 66.5, 2.5, 2.5)
                    value.categoria === 'BPM'
                        ? doc.text('X', 161.25, 67.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('HACCP', 166.5, 67.75, {baseline: 'middle'})
                    doc.rect(176, 66.5, 2.5, 2.5)
                    value.categoria === 'HACCP'
                        ? doc.text('X', 177.25, 67.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('GESTIÓN AMBIENTAL', 32.5, 71.75, {
                      baseline: 'middle',
                    })
                    doc.rect(58.75, 70.5, 2.5, 2.5)
                    value.categoria === 'GESTIÓN AMBIENTAL'
                        ? doc.text('X', 60, 71.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('RESPONSABILIDAD SOCIAL', 65.25, 71.75, {
                      baseline: 'middle',
                    })
                    doc.rect(98.75, 70.5, 2.5, 2.5)
                    value.categoria === 'RESPONSABILIDAD SOCIAL'
                        ? doc.text('X', 100, 71.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('PROCESO TÉCNICO', 105.25, 71.75, {
                      baseline: 'middle',
                    })
                    doc.rect(129.75, 70.5, 2.5, 2.5)
                    value.categoria === 'PROCESO TÉCNICO'
                        ? doc.text('X', 131, 71.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text('OTROS', 136.25, 71.75, {baseline: 'middle'})
                    doc.rect(145.75, 70.5, 2.5, 2.5)
                    value.categoria === 'OTROS'
                        ? doc.text('X', 147, 71.75, {
                          align: 'center',
                          baseline: 'middle',
                        })
                        : ''

                    doc.text(
                        value.fecha != null ? value.fecha : '--',
                        20,
                        79.75,
                        {baseline: 'middle'}
                    )
                    doc.text(
                        value.hora_inicio != null ? value.hora_inicio : '--',
                        61.25,
                        79.75,
                        {baseline: 'middle'}
                    )
                    doc.text(
                        value.hora_fin != null ? value.hora_fin : '--',
                        118,
                        79.75,
                        {baseline: 'middle'}
                    )
                    doc.text(
                        value.total_horas != null ? value.total_horas : '--',
                        176.25,
                        79.75,
                        {baseline: 'middle'}
                    )
                    doc.text(value.sede != null ? value.sede : '--', 17, 87.75, {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 37.5,
                    })
                    doc.text(
                        value.departamento != null ? value.departamento : '--',
                        80,
                        87.75,
                        {
                          align: 'justify',
                          baseline: 'middle',
                          maxWidth: 72.5,
                        }
                    )
                    doc.text(
                        value.area != null ? value.area : '--',
                        164.5,
                        87.75,
                        {
                          align: 'justify',
                          baseline: 'middle',
                          maxWidth: 36,
                        }
                    )
                    doc.text(
                        value.seccion != null ? value.seccion : '--',
                        22,
                        95.75,
                        {
                          align: 'justify',
                          baseline: 'middle',
                          maxWidth: 72.5,
                        }
                    )
                    doc.text(
                        value.zona != null ? value.zona : '--',
                        107.75,
                        95.75,
                        {
                          align: 'justify',
                          baseline: 'middle',
                          maxWidth: 72.5,
                        }
                    )
                    doc.text(
                        value.planilla != null ? value.planilla : '--',
                        162.5,
                        95.75,
                        {
                          align: 'justify',
                          baseline: 'middle',
                          maxWidth: 72.5,
                        }
                    )
                    doc.text(
                        value.cultivo != null ? value.cultivo : '--',
                        21.25,
                        103.75,
                        {
                          align: 'justify',
                          baseline: 'middle',
                          maxWidth: 72.5,
                        }
                    )
                    doc.text(
                        value.unidad != null ? value.unidad : '--',
                        117.25,
                        103.75,
                        {
                          align: 'justify',
                          baseline: 'middle',
                          maxWidth: 72.5,
                        }
                    )
                    doc.text(
                        value.expositor != null ? value.expositor : '--',
                        56.25,
                        114,
                        {
                          align: 'center',
                          baseline: 'middle',
                        }
                    )
                    doc.text(
                        value.procedencia_expositor != null
                            ? value.procedencia_expositor
                            : '--',
                        153.75,
                        114,
                        {
                          align: 'center',
                          baseline: 'middle',
                        }
                    )
                  } else {
                    doc.addPage()
                    doc.setLineWidth(0.4)
                    doc.rect(7.5, 7.5, 195, 15)
                    doc.setLineWidth(0.225)
                    doc.line(46.5, 7.5, 46.5, 22.5)
                    doc.line(163.5, 7.5, 163.5, 22.5)
                    doc.line(46.5, 15, 163.5, 15)

                    doc.addImage(
                        imgLogo,
                        'PNG',
                        20.5,
                        8.5,
                        13,
                        13,
                        'agv',
                        'NONE',
                        0
                    )
                    doc.addImage(
                        imgSello,
                        'PNG',
                        180,
                        276,
                        13,
                        13,
                        'selloagv',
                        'NONE',
                        0
                    )
                    // value.firma_expositor !== null && value.firma_expositor !== '' ? await yo.addImageAsync(doc, axiosIns.defaults.baseURL + value.firma_expositor, "PNG", 50.5, 268.5, 20, 13, "firmaexp", "NONE", 0) : ""
                    value.firma_expositor !== null && value.firma_expositor !== ''
                        ? await yo.addImageAsync(
                            doc,
                            axiosIns.defaults.baseURL + value.firma_expositor,
                            'PNG',
                            50.5,
                            268.5,
                            20,
                            13,
                            'firmaexp',
                            'NONE',
                            0
                        )
                        : value.expositor != null
                            ? doc.text(value.expositor, 50.5, 277.5, {
                              align: 'center',
                              baseline: 'middle',
                              maxWidth: 50,
                            })
                            : ''

                    doc.setFontSize(8)
                    doc.text('FORMATO', 105, 11.25, {
                      align: 'center',
                      baseline: 'middle',
                    })
                    doc.text(
                        'REGISTRO DE INDUCCIÓN, CAPACITACIÓN, ENTRENAMIENTO Y SIMULACRO',
                        105,
                        18.75,
                        {
                          align: 'center',
                          baseline: 'middle',
                        }
                    )
                    doc.setFontSize(6)
                    doc.text(
                        `Código: GH-GD-FO-0609\nRevisión: 006\nFecha: 03/12/2021\nPágina: ${j} de ${totalHojas}`,
                        165,
                        12.125,
                        {align: 'left'}
                    )

                    doc.line(182.5, 28.5, 202.5, 28.5)
                    doc.text(
                        value.n_acta != null
                            ? `${value.n_acta.toString()
                                .padStart(6, '0')}`
                            : '0'.padStart(6, '0'),
                        192.5,
                        27.75,
                        {align: 'center'}
                    )
                    doc.setFont(undefined, 'bold')
                    doc.text('CÓDIGO DE ACTA: ', 181.5, 27.75, {
                      align: 'right',
                    })
                    doc.setFontSize(8)
                    doc.text('LISTA DE PARTICIPANTES', 110, 33, {
                      align: 'center',
                    })

                    doc.text('N°', 9, 40, {baseline: 'middle'})
                    doc.text('DNI', 22.25, 40, {
                      align: 'center',
                      baseline: 'middle',
                    })
                    doc.text('FIRMA', 191.25, 40, {
                      align: 'center',
                      baseline: 'middle',
                    })
                    doc.text('ÁREA / CARGO', 68.5, 40, {
                      align: 'center',
                      baseline: 'middle',
                    })
                    doc.text('APELLIDOS Y NOMBRES', 138, 40, {
                      align: 'center',
                      baseline: 'middle',
                    })

                    doc.line(40, 282.5, 80, 282.5)
                    doc.text('FIRMA DEL EXPOSITOR', 60, 285.75, {
                      align: 'center',
                      baseline: 'bottom',
                    })
                    doc.text(
                        value.dni_expositor != null
                            ? `DNI: ${value.dni_expositor}`
                            : 'DNI: --',
                        60,
                        289.5,
                        {
                          align: 'center',
                          baseline: 'bottom',
                        }
                    )

                    doc.line(110, 289.5, 170, 289.5)
                    doc.line(110, 286, 170, 286)
                    doc.line(110, 282.5, 170, 282.5)
                    doc.line(110, 279, 170, 279)
                    doc.line(110, 275.5, 170, 275.5)

                    doc.line(110, 275.5, 110, 289.5)
                    doc.line(170, 275.5, 170, 289.5)

                    doc.setFont(undefined, 'normal')
                    doc.setFontSize(4.5)
                    doc.text(
                        `NÚMERO DE CAPACITADOS: ${
                            value?.n_asistentes === undefined
                                ? value.nasistentes
                                : value.n_asistentes
                        }`,
                        111.5,
                        278,
                        {baseline: 'bottom'}
                    )
                    doc.text(
                        'RAZON SOCIAL: Agrovision Perú S.A.C',
                        111.5,
                        281.5,
                        {baseline: 'bottom'}
                    )
                    doc.text(
                        'RUC: 20554556192    DIRECCIÓN: Jacarandas #490',
                        111.5,
                        285,
                        {baseline: 'bottom'}
                    )
                    doc.text(
                        'ACTIVIDAD DE LA EMPRESA: Agroindustria',
                        111.5,
                        288.5,
                        {baseline: 'bottom'}
                    )

                    let pp = 52.75
                    let ww = 52.25
                    let co = 0
                    const tot =
                        value?.n_asistentes === undefined
                            ? value.nasistentes
                            : value.n_asistentes

                    ini = ini + 20
                    fin = fin + 20

                    doc.setFontSize(6)
                    for (let i = ini; i <= fin; i++) {
                      doc.line(14, pp, 30.5, pp)
                      doc.line(33.5, pp, 63.25, pp)
                      doc.line(64.75, pp, 103.5, pp)
                      doc.line(106.5, pp, 180, pp)
                      doc.line(183, pp, 201, pp)

                      doc.text('/', 64, pp, {
                        align: 'center',
                        baseline: 'bottom',
                      })
                      doc.text(`${i}`, 10, pp, {
                        align: 'center',
                        baseline: 'bottom',
                      })

                      if (i <= tot) {
                        doc.setFontSize(6.75)
                        doc.setFont('helvetica', 'normal', 'normal')
                        doc.text(asistentes[i - 1].dni, 22.25, ww, {
                          align: 'center',
                          baseline: 'bottom',
                        })
                        doc.text(asistentes[i - 1].nombres, 143.25, ww, {
                          align: 'center',
                          baseline: 'bottom',
                        })
                        doc.setFontSize(6)
                        doc.text(asistentes[i - 1].area, 48.375, ww - 3, {
                          align: 'center',
                          baseline: 'ideographic',
                          maxWidth: 28,
                        })
                        doc.setFontSize(6.75)
                        doc.text(asistentes[i - 1].cargo, 84.125, ww - 3, {
                          align: 'center',
                          baseline: 'ideographic',
                          maxWidth: 36,
                        })

                        doc.setFont('courier', 'italic', 'bold')
                        doc.setFontSize(4.25)

                        // asistentes[i - 1].firma_foto !== null && asistentes[i - 1].firma_foto !== '' ? await yo.addImageAsync(doc, axiosIns.defaults.baseURL + asistentes[i - 1].firma_foto, "PNG", 186, ww - 8, 12, 8) : ""
                        asistentes[i - 1].firma_foto !== null &&
                        asistentes[i - 1].firma_foto !== ''
                            ? await yo.addImageAsync(
                                doc,
                                axiosIns.defaults.baseURL +
                                asistentes[i - 1].firma_foto,
                                'PNG',
                                186,
                                ww - 8,
                                12,
                                8
                            )
                            : doc.text(asistentes[i - 1].nombres, 192, ww - 8 + 5, {
                              align: 'center',
                              baseline: 'middle',
                              maxWidth: 20,
                            })
                      }
                      doc.setFontSize(6)
                      doc.setFont('helvetica', 'normal', 'normal')

                      pp = pp + 11
                      ww = ww + 11
                      co++
                    }
                  }
                }

                const nomms =
                    value.n_acta != null
                        ? value.n_acta.toString()
                            .padStart(6, '0')
                        : '000000'
                doc.save(
                    'Reporte PDF Asistencias - N° ' +
                    nomms +
                    ' - ' +
                    value.empresa +
                    '.pdf'
                )
              }
            })
            .catch(function (error) {
              console.log(error)
            })
            .finally(function () {
              yo.loadingPDF = false
              yo.estado = false
            })

        pdfCounter++
      }
    },

    realizarFiltro(cabecera, data) {
      const yo = this
      let spd = yo.items

      let filt = []
      let c = 0

      let fecha = yo.fechaFiltro
      let fechaInicio = ''
      let fechaFin = ''
      let fechaHoy = ''

      if (fecha !== null && fecha !== '') {
        fecha = fecha.split(' a ')
        if (fecha.length === 1) {
          const [dia, mes, anio] = fecha[0].split('/')
          fechaInicio = new Date(+anio, mes - 1, +dia)
          fechaFin = new Date(+anio, mes - 1, +dia, 23, 59, 59)
        } else {
          const [dia, mes, anio] = fecha[0].split('/')
          const [dia1, mes1, anio1] = fecha[1].split('/')
          fechaInicio = new Date(+anio, mes - 1, +dia)
          fechaFin = new Date(+anio1, mes1 - 1, +dia1)
        }
      }

      for (const valor of yo.filtro) {
        if (valor.nombre === cabecera) {
          yo.filtro[c].valor = data
        }

        if (valor.nombre === 'fecha' && data.length === 0) {
          yo.fechaFiltro = null
          yo.filtro[c].valor = data
        }

        c += 1
      }

      for (const values of yo.filtro) {
        for (const column of values.valor) {
          spd.forEach(function (value) {
            if (column === 'VACIOS') {
              if (
                  value[values.nombre] === null ||
                  value[values.nombre] === '' ||
                  value[values.nombre] === ' ' ||
                  value[values.nombre] === '  '
              ) {
                filt.push(value)
              }
            } else {
              if (values.nombre === 'fecha' && column !== null) {
                const [anios, mess, dias] = value.fecha.split('-')
                fechaHoy = new Date(+anios, mess - 1, +dias)

                if (fechaInicio !== '' && fechaFin !== '') {
                  if (
                      fechaHoy.getTime() >= fechaInicio.getTime() &&
                      fechaHoy.getTime() <= fechaFin.getTime()
                  ) {
                    filt.push(value)
                  }
                }
              } else {
                if (value[values.nombre] === column) {
                  filt.push(value)
                }
              }
            }
          })
        }

        if (values.valor.length > 0) {
          if (values.valor[0] !== null) {
            spd = filt
            filt = []
          }
        }
      }

      yo.itemsFiltro = spd
    },

    buscar() {
      const yo = this
      yo.loading = true
      yo.tabla.updateData([])
      yo.totalRows = 0
      // ----------------i

      const data = JSON.stringify({
        dni_nombre: yo.busqueda,
      })

      const config = {
        method: 'post',
        url: '/capacitacion/asistentes/filter/',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              // console.log(response.data)
              yo.itemsFiltro = response.data

              yo.tabla.updateData(response.data)
              yo.settings.hiddenColumns = {
                columns: [0, 1, 24],
              }

              yo.tabla.updateSettings(yo.settings)

              // yo.tabla.getPlugin('filters').addCondition(16, 'by_value', [['2023-06']])
              // yo.tabla.getPlugin('filters').filter()
              yo.tabla.getPlugin('autoColumnSize')
                  .recalculateAllColumnsWidth()

              yo.totalRows = response.data.length

              yo.loadingFiltro = true
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading = false
          })

      // ----------------f
    },

    verLinks(id, tema, creado) {
      this.verLink = true

      const url_base = window.location.origin

      /*
      const fecha = new Date(creado);

      const dia = fecha.getDate().toString().padStart(2, '0');
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const anio = fecha.getFullYear().toString();
      const hora = fecha.getHours().toString().padStart(2, '0');
      const minuto = fecha.getMinutes().toString().padStart(2, '0');
      const segundo = fecha.getSeconds().toString().padStart(2, '0');

      const fechaHoraFormateada = `${dia}-${mes}-${anio} ${hora}:${minuto}:${segundo}`;
      */

      let result = ''
      const characters =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      for (let i = 0; i < 16; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * characters.length)
        )
      }

      this.link =
          url_base +
          '/capacitacion/virtual/new/' +
          tema +
          '/' +
          id +
          '/' +
          result +
          '/' +
          creado
      // console.log(this.link)
    },

    afterFilterFuncion(conditionsStack) {
      // console.log(conditionsStack[0].column)
      const yo = this
      // yo.tabla.getPlugin('filters').filter()
      yo.totalRows = yo.tabla.getData().length
      yo.tabla.getPlugin('autoColumnSize')
          .recalculateAllColumnsWidth()
      // yo.tabla.getPlugin('autoColumnSize').calculateAllColumnsWidth(6)
      yo.loadingFiltro = false

      //////////////yo.totalRows = yo.tabla.getPlugin('filters').getDataMapAtColumn().length
    },

    borrarFiltro() {
      const yo = this
      // yo.tabla.getPlugin('filters').filter()
      yo.tabla.getPlugin('filters')
          .clearConditions()
      yo.tabla.getPlugin('filters')
          .filter()

      yo.loadingFiltro = true
    },

    borrarBusqueda() {
      const yo = this
      yo.tabla.updateData(yo.items)
      yo.settings.hiddenColumns = {
        columns: [0, 1, 24],
      }

      yo.tabla.updateSettings(yo.settings)

      // yo.tabla.getPlugin('filters').addCondition(16, 'by_value', [['2023-06']])
      // yo.tabla.getPlugin('filters').filter()

      yo.totalRows = yo.items.length

      yo.loadingFiltro = true

      yo.busqueda = null
      yo.itemsFiltro = []
    },

    rellenarVacios() {
      const yo = this
      yo.loadingASI = true

      const config = {
        method: 'get',
        url: '/capacitacion/asistentes/exportar/rellenar/',
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              //Sitodo salió bien, envío mensaje
              yo.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: 'Función ejecutada exitosamente',
                      icon: 'CheckIcon',
                      text:
                          'Se actualizaron con éxito los datos de ' +
                          response.data['updates'] +
                          ' asistentes.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  }
              )
            }
          })
          .catch(function (error) {
            console.log(error)
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la Actualización',
                icon: 'XIcon',
                text: 'Hubo un error en la actualización de registros, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingASI = false
          })
    },

    async addImageAsync(
        doc,
        url,
        format,
        x,
        y,
        width,
        height,
        alias,
        compression,
        rotation
    ) {
      try {
        const response = await axiosIns.head(url)
        if (response.status !== 200) {
          url = axiosIns.defaults.baseURL + '/media/fotos/firma_blank.png'
        }
      } catch (error) {
        url = axiosIns.defaults.baseURL + '/media/fotos/firma_blank.png'
      }

      // Ahora cargar la imagen y agregarla al documento
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = function () {
          doc.addImage(
              this,
              format,
              x,
              y,
              width,
              height,
              alias,
              compression,
              rotation
          )
          resolve()
        }
        img.src = url
      })
    },

    async addImageAsync2(doc, url) {
      console.log("Cargando imagen desde:", url);
      try {
        const response = await axiosIns.head(url)
        if (response.status !== 200) {
          url = axiosIns.defaults.baseURL + '/media/fotos/firma_blank.png'
        }
      } catch (error) {
        url = axiosIns.defaults.baseURL + '/media/fotos/firma_blank.png'
      }
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = function () {
          console.log("Imagen cargada:", url);
          const imgWidth = img.width
          const imgHeight = img.height

          const ratio = Math.min(154 / imgWidth, 221 / imgHeight)
          const newWidth = imgWidth * ratio
          const newHeight = imgHeight * ratio

          if (newWidth >= newHeight) {
            doc.addImage(
                this,
                'PNG',
                28,
                38,
                newWidth,
                newHeight,
                'imgcapa',
                'NONE',
                0
            )
          } else {
            doc.addImage(
                this,
                'PNG',
                28,
                -114,
                newHeight,
                newWidth,
                'imgcapa',
                'NONE',
                270
            )
          }

          resolve()
        }
        img.onerror = function () {
          console.error("Error cargando la imagen:", url);
          resolve();
        };

        img.src = url

        console.log("Función", url)
      })
    },

    mostrarSwal() {
      this.swalInstance = this.$swal.fire({
        title: 'Generando PDF...',
        text: 'Por favor espere, se está generando el(los) documento(s)',
        footer: 'No cierre la ventana',
        imageUrl: require('@/assets/images/loading/loading.gif'),
        imageWidth: 150,
        imageHeight: 150,
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
    },
    ocultarSwal() {
      if (this.swalInstance) {
        this.swalInstance.close()
      }
    },
    abrirModalEditar(datos) {
      this.mostrarModalEditar = true
      this.idEditarRegistro = datos['id']
      this.dni = datos['dni']
      this.nombres = datos['nombres']
      this.generoSelected = datos['genero']
      this.cargo = datos['cargo']
      this.area = datos['area']
      this.planilla = datos['planilla']
    },
    editarRegistro() {
      const yo = this
      this.$refs.editarAsistente.validate()
          .then((success) => {
            if (success) {
              yo.loadingEditar = true

              const data = JSON.stringify({
                nombres: yo.nombres,
                cargo: yo.cargo,
                area: yo.area,
                planilla: yo.planilla,
                genero: yo.generoSelected,
              })
              const config = {
                method: 'put',
                url: 'capacitacion/asistentes/editar-v2/' + yo.idEditarRegistro,
                headers: {
                  'Content-Type': 'application/json',
                },
                data: data,
              }

              axiosIns(config)
                  .then(function (response) {
                    if (response.status === 200) {
                      yo.mostrarNotificacion(
                          '¡Bien hecho!',
                          'CheckIcon',
                          'El registro se editó correctamente.',
                          'success',
                          5000
                      )
                    }
                  })
                  .catch(function (error) {
                    console.log(error)
                    yo.mostrarNotificacion(
                        'Error en la edición.',
                        'BellIcon',
                        error.toString(),
                        'danger',
                        5000
                    )
                  })
                  .finally(function () {
                    yo.mostrarAsistente(yo.idCapacitacion, yo.tema)
                    yo.$nextTick(() => {
                      yo.$refs['modal-editar'].toggle('#toggle-btn')
                    })
                    yo.loadingEditar = false
                  })
            }
          })
    },
    okModalEditar(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.editarRegistro()
    },
    mostrarNotificacion(titulo, icono, texto, variante, tiempo) {
      this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante,
            },
          },
          {
            timeout: tiempo,
            position: 'top-center',
          }
      )
    },

    verMateriales(id, tema) {
      this.verModalMaterial = true
      this.idMaterial = id
      this.temaMaterial = tema
    },

    descargarMaterial(link) {
      const yo = this
      if (link !== null && link !== '') {
        const config = {
          method: 'get',
          url: link,
          headers: {
            'Content-Type': 'application/json',
          },
        }

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {

                const a = document.createElement('a');

                a.href = axiosIns.defaults.baseURL + link;
                a.target = '_blank';
                a.download = link.split('/').pop();  // Intenta obtener el nombre del archivo del URL
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              } else {
                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Advertencia',
                    icon: 'XIcon',
                    text: 'No se encontró un material asignado a esta capacitación.',
                    variant: 'warning',
                  },
                })
              }
            })
            .catch(function (error) {
              console.log(error)
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Advertencia',
                  icon: 'XIcon',
                  text: 'No se encontró un material asignado a esta capacitación.',
                  variant: 'warning',
                },
              })
            })
      } else {
        yo.$toast({
          component: ToastificationContent,
          props: {
            title: 'Advertencia',
            icon: 'XIcon',
            text: 'No se encontró un material asignado a esta capacitación.',
            variant: 'warning',
          },
        })
      }

    },

    generarListaMesesDesdeNoviembre2022() {
      let anio = 2022;
      let mes = 11; // Empezamos desde noviembre de 2022
      const hoy = new Date();
      const anioActual = hoy.getFullYear();
      const mesActual = hoy.getMonth() + 1; // Los meses en JS van de 0 a 11, sumamos 1
      let lista = [];

      while (anio < anioActual || (anio === anioActual && mes <= mesActual)) {
        let mesStr = mes < 10 ? `0${mes}` : `${mes}`; // Formatear mes con dos dígitos
        lista.unshift(`${anio}-${mesStr}`); // Insertar al inicio para mantener el orden descendente

        mes++; // Avanzamos un mes

        if (mes === 13) { // Si el mes llega a 13, avanzamos un año y reiniciamos el mes a enero
          mes = 1;
          anio++;
        }
      }

      this.mesesList = lista; // Se revierte para que esté en orden descendente
    }
  },
}
</script>

<style
    src="../../../node_modules/handsontable/dist/handsontable.full.css"
></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.alinear-medioA {
  vertical-align: middle !important;
}

.alinear-una-sola-linea {
  white-space: nowrap !important;
}

.tablitaA {
  min-height: 58vh !important;
}

.tablitaA::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}

.tablitaA::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}

.tablitaA::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}
</style>
